import React, { useEffect, useContext, useState } from "react";
import { FarmContext } from "../../contexts/FarmContext";
import { useTranslation } from "react-i18next";

import { RestAPI } from "@aws-amplify/api-rest";
import { useLocation } from "react-router";
import LoadingDialog from "../Utils/LoadingDialog";

import withName from "../../hoc/withName";

import { ConnectDialog, InfoDialog, FormDialog } from "./Dialogs";
import SelfHelp from "../Utils/SelfHelp";
import { SDBConverterDialog, SDBConverterInfoDialog } from "./SDBConverter";

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const Integradores = () => {
    const enableMarketplace = false;
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [_, dispatch] = useContext(FarmContext);
    const canAutorizarApi = dispatch({ type: "get", path: "canAutorizarApi" });
    const acceso_limitado = dispatch({ type: "get", path: "accesoLimitado" });
    const [connectDialogState, setConnectDialogState] = useState({ visible: false });
    const [formDialogState, setFormDialogState] = useState({ visible: false });
    const [infoDialogState, setInfoDialogState] = useState({ visible: false });
    const [sdbDialogState, setSdbDialogState] = useState({ visible: false });
    const [sdbInfoDialogState, setSdbInfoDialogState] = useState({ visible: false });
    const [firstExec, setFirstExec] = useState(true);
    const [distribuidores, setDistribuidores] = useState(null);
    const [paises, setPaises] = useState(null);
    const [distArr, setDistArr] = useState(null);
    const farmId = getFarm(location);
    const [dataLoading, setDataLoading] = useState(false);

    const selfHelpDisImg11 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-1.png`];
    const selfHelpDisImg12 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-2.png`];
    const selfHelpDisImg13 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-3.png`];
    const selfHelpDisImg21 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-4.png`];
    const selfHelpDisImg22 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-5-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-5-1.png`];
    const selfHelpDisImg23 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-5.png`];
    const selfHelpDisImg24 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-disponible-conectar-6.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-disponible-conectar-6.png`];
    const selfHelpDisImg41 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-configurar-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-configurar-1.png`];
    const selfHelpDisImg42 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-configurar-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-configurar-2.png`];
    const selfHelpDisImg43 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-configurar-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-configurar-3.png`];

    const selfHelpDisponibles = [
        {
            tab: 1, header: { text: t("selfHelp.integradores.disponibles.explicacion.msgIntro") }, params:
                [
                    { id: 1, text: t("selfHelp.integradores.disponibles.explicacion.msg1"), image: [] }
                ],
        },
        {
            tab: 2, header: { text: t("selfHelp.integradores.disponibles.autorizado.msgIntro") }, params:
                [
                    { id: 1, text: t("selfHelp.integradores.disponibles.autorizado.msg1"), image: selfHelpDisImg11 },
                    { id: 2, text: t("selfHelp.integradores.disponibles.autorizado.msg2"), image: selfHelpDisImg12 },
                    { id: 3, text: t("selfHelp.integradores.disponibles.autorizado.msg3"), image: selfHelpDisImg13 }
                ]
        },
        {
            tab: 3, header: { text: t("selfHelp.integradores.disponibles.autogestionado.msgIntro") }, params:
                [
                    { id: 1, text: t("selfHelp.integradores.disponibles.autogestionado.msg1"), image: selfHelpDisImg21 },
                    { id: 2, text: t("selfHelp.integradores.disponibles.autogestionado.msg2"), image: selfHelpDisImg22 },
                    { id: 3, text: t("selfHelp.integradores.disponibles.autogestionado.msg3"), image: selfHelpDisImg23 },
                    { id: 4, text: t("selfHelp.integradores.disponibles.autogestionado.msg4"), image: selfHelpDisImg24 }
                ],
        },
        {
            tab: 4, header: { text: t("selfHelp.sdb.conectar.header") }, params:
                [
                    { id: 1, text: t("selfHelp.sdb.conectar.msg1"), image: selfHelpDisImg41 },
                    { id: 2, text: t("selfHelp.sdb.conectar.msg2"), image: selfHelpDisImg42 },
                    { id: 3, text: t("selfHelp.sdb.conectar.msg3"), image: selfHelpDisImg43 }
                ]
        }
    ];

    const selfHelpConImg11 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-conectado-modificar-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-conectado-modificar-1.png`];
    const selfHelpConImg12 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-conectado-modificar-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-conectado-modificar-2.png`];
    const selfHelpConImg13 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-conectado-modificar-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-conectado-modificar-3.png`];
    const selfHelpConImg21 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-conectado-desconectar-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-conectado-desconectar-1.png`];
    const selfHelpConImg22 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-conectado-desconectar-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-conectado-desconectar-2.png`];
    const selfHelpConImg23 = import.meta.glob("../../img/autoayuda/*/autoayuda-integrador-conectado-desconectar-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-integrador-conectado-desconectar-3.png`];
    const selfHelpConImg41 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-conectado-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-conectado-1.png`];
    const selfHelpConImg42 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-conectado-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-conectado-2.png`];
    const selfHelpConImg43 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-conectado-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-conectado-3.png`];
    const selfHelpConImg44 = import.meta.glob("../../img/autoayuda/*/autoayuda-sdb-conectado-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-sdb-conectado-4.png`];

    const selfHelpConectados = [
        {
            tab: 1, header: { text: t("selfHelp.integradores.conectados.explicacion.msgIntro") }, params:
                [
                    { id: 1, text: t("selfHelp.integradores.conectados.explicacion.msg1"), image: [] }
                ],
        },
        {
            tab: 2, header: { text: t("selfHelp.integradores.conectados.modificar.msgIntro") }, params:
                [
                    { id: 1, text: t("selfHelp.integradores.conectados.modificar.msg1"), image: selfHelpConImg11 },
                    { id: 2, text: t("selfHelp.integradores.conectados.modificar.msg2"), image: selfHelpConImg12 },
                    { id: 3, text: t("selfHelp.integradores.conectados.modificar.msg3"), image: selfHelpConImg13 }
                ]
        },
        {
            tab: 3, header: { text: t("selfHelp.integradores.conectados.desconectar.msgIntro") }, params:
                [
                    { id: 1, text: t("selfHelp.integradores.conectados.desconectar.msg1"), image: selfHelpConImg21 },
                    { id: 2, text: t("selfHelp.integradores.conectados.desconectar.msg2"), image: selfHelpConImg22 },
                    { id: 3, text: t("selfHelp.integradores.conectados.desconectar.msg3"), image: selfHelpConImg23 }
                ],
        },
        {
            tab: 4, header: { text: t("selfHelp.sdb.info.header") }, params:
                [
                    { id: 1, text: t("selfHelp.sdb.info.msg1"), image: selfHelpConImg41 },
                    { id: 2, text: t("selfHelp.sdb.info.msg2"), image: selfHelpConImg42 },
                    { id: 3, text: t("selfHelp.sdb.info.msg3"), image: selfHelpConImg43 },
                    { id: 4, text: t("selfHelp.sdb.info.msg4"), image: selfHelpConImg44 },
                ]
        }
    ];

    const openDialog = (row) => {
        if (!row.esta_conectado) {
            if (row.distribuidor_id === 3034) {
                setSdbDialogState({ data: row, visible: true, headerText: t("sdb.title") });
            } else if (!row.es_autogestionado) {
                setConnectDialogState({ data: row, visible: true });
            } else {
                setFormDialogState({ data: row, visible: true, headerText: t("sass.form.integrador_autogestionado") });
            }
        } else {
            if (row.distribuidor_id === 3034) {
                setSdbInfoDialogState({ data: row, visible: true, headerText: t("sdb.title") });
            } else {
                setInfoDialogState({ data: row, visible: true });
            }
        }
    };

    const getDatos = async () => {
        setDataLoading(true);
        await Promise.all([
            RestAPI.get("apiAdminDropControl", `/farms/${farmId}/distribuidores`).then(res => {
                //const resFiltered = res.filter(d => d.habilitado_marketplace || d.is_old );
                setDistArr(res);
            }),
            RestAPI.get("apiAdminDropControl", `/farms/${farmId}/paises`).then(res => { setPaises(res); })]);
        setDataLoading(false);
    };

    useEffect(() => {
        if (firstExec) {
            getDatos();
            setFirstExec(false);
        }
    }, [firstExec]);

    useEffect(() => {
        if (distArr !== null) {

            const auto_gestionado = {
                nombre: "AUTO-GESTIONADO",
                es_api: true,
                habilitado_marketplace: true,
                es_autogestionado: true
            };
            const data = {
                conectados: [],
                disponibles: []
            };
            distArr.forEach((e) => {
                if (e.esta_conectado) {
                    data.conectados.push(e);
                } else {
                    data.disponibles.push(e);
                }
            });
            if(!enableMarketplace){
                data.disponibles.push(auto_gestionado);
            }
            setDistribuidores(data);

        }
    }, [distArr]);

    const updateDistribuidores = (distribuidor, add) => {
        getDatos();
        /*
        if (distribuidor === null) return;
        console.log("Distribuidor updated", distribuidor);
        if (add) {
            setDistArr(distArr.concat([distribuidor]));
        } else {
            const index = distArr.findIndex((d) => d.distribuidor_id === distribuidor.distribuidor_id);
            if (index >= 0) {
                const distArrUpdated = distArr.map(d => {
                    if (d.distribuidor_id === distribuidor.distribuidor_id) {
                        return distribuidor;
                    }
                    return d;
                });

                setDistArr(distArrUpdated);
            }
        }
*/
    };

    return (
        <div id="integradoresContainer" className='row-container'>
            {dataLoading && <LoadingDialog appendTo="self" />}
            <div className="col-xl-12 col-lg-12 col-sm-12">
                <ConnectDialog campoId={farmId} dialogState={connectDialogState} setDialogState={setConnectDialogState} update={updateDistribuidores} />
                <FormDialog campoId={farmId} dialogState={formDialogState} setDialogState={setFormDialogState} paisesList={paises} update={updateDistribuidores} />
                <InfoDialog campoId={farmId} dialogState={infoDialogState} setDialogState={setInfoDialogState} update={updateDistribuidores} acceso_limitado={acceso_limitado} />
                <SDBConverterDialog campoId={farmId} dialogState={sdbDialogState} setDialogState={setSdbDialogState} update={updateDistribuidores} setInfoDialog={setSdbInfoDialogState} />
                <SDBConverterInfoDialog campoId={farmId} dialogState={sdbInfoDialogState} setDialogState={setSdbInfoDialogState} update={updateDistribuidores} acceso_limitado={acceso_limitado} />
                <div className="card">
                    <div className="card-body">
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                {selfHelpConectados &&
                                    <SelfHelp t={t} lng={i18n.language} params={selfHelpConectados} fertiTable />}
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("sass.integradores_conectados")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 text-right' />
                        </div>

                        <div className='linea-titulo' />

                        <div className='row'>
                            {distribuidores && distribuidores.conectados.map((row, index) => (
                                <div key={index} className='e-card' onClick={() => { canAutorizarApi && openDialog(row); }}>
                                    {row.distribuidor_id === 3034 ?
                                        <div className="e-card-image" >
                                            <div className="e-card-title" style={{ height: "160px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                {row.nombre}
                                            </div>
                                        </div> : row.is_old ?
                                            <div className="e-card-image" style={{ backgroundImage: `url(https://static.dropcontrol.com/${row.imagen})` }}>
                                                <div className="e-card-title">
                                                    {`${row.nombre} (${t("sass.integracionAnterior")})`}
                                                </div>
                                            </div>
                                            : row.habilitado_marketplace ?
                                                <div className="e-card-image" style={{ backgroundImage: `url(https://static.dropcontrol.com/${row.imagen})` }}>
                                                    <div className="e-card-title">
                                                        {row.nombre}
                                                    </div>
                                                </div>
                                                : <div className="e-card-image">
                                                    <div className='e-card-content' style={{ height: "160px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <h5>{t("sass.autogestionado")}</h5>
                                                    </div>
                                                    <div className="e-card-title">
                                                        {row.nombre}
                                                    </div>
                                                </div>}
                                </div>
                            ))}

                        </div>

                    </div>
                </div>
                {!acceso_limitado && canAutorizarApi && <div className="card">
                    <div className="card-body">
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                {selfHelpDisponibles &&
                                    <SelfHelp t={t} lng={i18n.language} params={selfHelpDisponibles} fertiTable />}
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("sass.integradores_disponibles")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 text-right' />
                        </div>

                        <div className='linea-titulo' />

                        <div className='row'>
                            {canAutorizarApi && distribuidores && distribuidores.disponibles.map((row, index) => (row.habilitado_marketplace &&
                                <div key={index} className='e-card' onClick={() => { canAutorizarApi && openDialog(row); }}>
                                    {row.distribuidor_id === 3034 ?
                                        <div className="e-card-image" >
                                            <div className="e-card-title" style={{ height: "160px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                {row.nombre}
                                            </div>
                                        </div> : row.es_autogestionado ?
                                            <div className="e-card-image" >
                                                <div className="e-card-title" style={{ height: "160px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    {t("sass.autogestionado")}
                                                </div>
                                            </div>
                                            : <div className="e-card-image" style={{ backgroundImage: `url(https://static.dropcontrol.com/${row.imagen})` }}>
                                                <div className="e-card-title">
                                                    {row.nombre}
                                                </div>
                                            </div>}
                                </div>
                            ))}

                        </div>

                    </div>
                </div>}
            </div>
        </div>
    );
};

export default withName(Integradores, "IntegradoresFrag");
